const translations = {
    thirdPartyWorkOrderNumber: 'Third Party Work Order #'
};

export default translations;
